export default function AboutStorySection() {
  return (
    <section className="bg-background-50 py-16 md:py-28 lg:py-32">
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-4xl mx-auto">
        {/* Eyebrow */}
        <p className="text-accent-600 text-xs font-body tracking-[0.25em] uppercase mb-4 text-center font-medium">
          The story
        </p>

        {/* Headline */}
        <h2 className="font-heading text-xl md:text-3xl lg:text-5xl text-foreground-950 text-center mb-10 leading-tight">
          This work is not what I do. It is who I am.
        </h2>

        {/* Body — Mandie's voice */}
        <div className="space-y-6">
          <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed">
            I built this work from the inside out. Before I was a clinical psychologist, before the certifications, the sessions, and the hundreds of women I have had the privilege of sitting with, I was a woman who knew what it felt like to be disconnected from herself. To perform. To shrink. To keep giving from a place that had long since run dry.
          </p>
          <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed">
            The training gave me the language. The lived experience gave me the understanding. And the women I have worked with, every single one, have taught me that healing is not a destination. It is a return.
          </p>
          <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed">
            My work sits at the intersection of clinical psychology, somatic healing, and spiritual truth. I do not choose between the science and the soul. I hold both, because the women I work with need both.
          </p>
          <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed">
            In our work together you will not be managed. You will not be given strategies to survive your life more efficiently. You will be met, in the truest most complete sense of that word, and walked back home to yourself.
          </p>
        </div>
      </div>
    </section>
  );
}